import { Routes } from '@angular/router';
import { ListCompanyComponent } from './module/company/components/list-company/list-company.component';
import { ListVehicleComponent } from './module/vehicle/components/list-vehicle/list-vehicle.component';
import { CreateVehicleComponent } from './module/vehicle/components/create-vehicle/create-vehicle.component';
import { DetailVehicleComponent } from './module/vehicle/components/detail-vehicle/detail-vehicle.component';
import { LoginComponent } from './module/login/login.component';
import { MainPageComponent } from './module/main-page/main-page.component';
import { ListDriverComponent } from './module/driver/components/list-driver/list-driver.component';
import { CreateDriverComponent } from './module/driver/components/create-driver/create-driver.component';
import { DetailDriverComponent } from './module/driver/components/detail-driver/detail-driver.component';
import { ListStoreComponent } from './module/store/components/list-store/list-store.component';
import { CreateStoreComponent } from './module/store/components/create-store/create-store.component';
import { DetailStoreComponent } from './module/store/components/detail-store/detail-store.component';
import { EditStoreComponent } from './module/store/components/edit-store/edit-store.component';
import { CreateProductComponent } from './module/store/components/product/create-product.component';
import { EditProductComponent } from './module/store/components/product/edit-product.component';
import { MyStoreDetailComponent } from './module/my-store/components/my-store-detail/my-store-detail.component';
import { MyStoreEditComponent } from './module/my-store/components/my-store-edit/my-store-edit.component';
import { MyStoreProductListComponent } from './module/my-store/components/product/my-store-product-list/my-store-product-list.component';
import { MyStoreProductCreateComponent } from './module/my-store/components/product/my-store-product-create/my-store-product-create.component';
import { MyStoreProductEditComponent } from './module/my-store/components/product/my-store-product-edit/my-store-product-edit.component';
import { MapaComponent } from './module/mapa/mapa.component';
import { canActivateGuard } from './core/service/AuthGuard';
import { DashboardComponent } from './module/dashboard/dashboard.component';
import { RegistroProcpectoComponent } from './prospecto/registro-procpecto/registro-procpecto.component';
import { UserDeleteComponent } from './user-delete/user-delete.component';
import { ListUserComponent } from './module/user/list-user/list-user.component';
import { ListCarTripComponent } from './module/cartrip/list-car-trip/list-car-trip.component';
import { ListComponent } from './module/notification/list/list.component';
import { ListPublicityComponent } from './module/publicity/list-publicity/list-publicity.component';
import { CreatePublicityComponent } from './module/publicity/create-publicity/create-publicity.component';
import { RideRequestComponent } from './module/ride-request/ride-request.component';
import { FoodOrderListComponent } from './module/food-orders/food-order-list/food-order-list.component';
import { FoodOrderHistoryComponent } from './module/food-orders/food-order-history/food-order-history.component';
import { FoodOrderDetailComponent } from './module/food-orders/food-order-detail/food-order-detail.component';
import { DriverDeleteComponent } from './driver-delete/driver-delete.component';
import { TripDetailComponent } from './module/ride-request/trip-detail/trip-detail.component';

export const routes: Routes = [
  {
    path: 'registro-prospecto',
    component: RegistroProcpectoComponent,
  },
  {
    path: 'registro-prospecto/registro-exitoso',
    component: RegistroProcpectoComponent,
  },
  {
    path: 'delete-user',
    component: UserDeleteComponent,
  },
  {
    path: 'delete-driver',
    component: DriverDeleteComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'admin',
    component: MainPageComponent,
    canActivate: [canActivateGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'notifications', component: ListComponent },
      { path: 'publicity', component: ListPublicityComponent },
      {
        path: 'publicity',
        children: [
          { path: 'create', component: CreatePublicityComponent }
        ]
      },
      { path: 'company', component: ListCompanyComponent },
      { path: 'vehicle', component: ListVehicleComponent },
      {
        path: 'vehicle',
        children: [
          { path: 'create', component: CreateVehicleComponent },
          { path: 'detail/:idvehicle', component: DetailVehicleComponent },
        ],
      },
      { path: 'driver', component: ListDriverComponent },
      {
        path: 'driver',
        children: [
          { path: 'create', component: CreateDriverComponent },
          { path: 'detail/:iddriver', component: DetailDriverComponent },
        ],
      },
      { path: 'store', component: ListStoreComponent },
      {
        path: 'store',
        children: [
          { path: 'create', component: CreateStoreComponent },
          { path: 'detail/:idstore', component: DetailStoreComponent },
          { path: 'edit/:idstore', component: EditStoreComponent },
          { path: ':idstore/product/create', component: CreateProductComponent },
          { path: ':idstore/product/edit/:idproduct', component: EditProductComponent },
        ],
      },
      {
        path: 'my-store',
        children: [
          { path: '', component: MyStoreDetailComponent },
          { path: 'edit', component: MyStoreEditComponent },
          { path: 'products', component: MyStoreProductListComponent },
          { path: 'products/create', component: MyStoreProductCreateComponent },
          { path: 'products/edit/:idproduct', component: MyStoreProductEditComponent },
        ],
      },
      { path: 'mapa', component: MapaComponent },
      { path: 'ride-request', component: RideRequestComponent },
      { path: 'ride-request/detail/:idTrip', component: TripDetailComponent },
      { path: 'food-orders', component: FoodOrderListComponent },
      { path: 'food-orders/history', component: FoodOrderHistoryComponent },
      { path: 'food-orders/detail/:idOrder', component: FoodOrderDetailComponent },
      {
        path: 'user',
        children: [
          { path: 'list-users', component: ListUserComponent },
        ],
      },
      {
        path: 'car-trip',
        children: [
          { path: 'list-car-trips', component: ListCarTripComponent },
        ],
      }
    ],
  },
];
